export const LABEL = 'Buy for {price}';
export const FREE_LABEL = 'Register Now';
